import { all, fork } from 'redux-saga/effects';
import authSagas from './authSagas';
import countriesSagas from './countriesSagas';
import dynastiesSagas from './dynastiesSagas';
import buildingsSagas from './instances/buildingsSagas';
// eslint-disable-next-line import/no-named-default
import { default as BuildingComponentInstance } from './instances/componentsSagas';
// eslint-disable-next-line import/no-named-default
import { default as BuildingElementInstance } from './instances/elementsSagas';
import productsSagas from './instances/productsSagas';
import contextsSagas from './instances/contexts';
import characteristicsSagas from './instances/characteristicsSagas';
import appSagas from './appSagas';
import tagsSagas from './tagsSagas';
import usersSagas from './usersSagas';

export default function* rootSaga() {
  return yield all([
    fork(authSagas),
    fork(countriesSagas),
    fork(dynastiesSagas),
    fork(appSagas),
    fork(BuildingComponentInstance),
    fork(BuildingElementInstance),
    fork(tagsSagas),
    fork(buildingsSagas),
    fork(productsSagas),
    fork(contextsSagas),
    fork(characteristicsSagas),
    fork(usersSagas),
  ]);
}
